import { message } from 'antd';
import { useTranslation } from 'react-i18next';

function errorHandler(error) {
  let errMsg = 'errors.general';
  if (
    (error?.data && error?.data?.message) ||
    (error?.response && error?.response?.status)
  ) {
    const response = error?.data || error?.response?.data;
    const statusCode = error?.status || error?.response.status;

    switch (statusCode) {
      case 404:
        errMsg = 'errors.resourceNotFound';
        break;
      case 422:
        errMsg = response?.message;
        break;
      case 500:
        if (response?.message !== null) {
          errMsg = response?.message;
        } else {
          errMsg = 'errors.internalServerError';
        }
        break;
      default:
        errMsg = response?.message;
        break;
    }
  } else if (error?.message) {
    errMsg = error?.message;
  }
  return errMsg;
}

export function useCheckResponse() {
  const { t } = useTranslation();

  const checkResponse = (
    res: any,
    type?:
      | 'create'
      | 'update'
      | 'send'
      | 'buy'
      | 'upload'
      | 'submit'
      | 'signout'
      | 'verify',
    name?: string
  ) => {
    const element = document.getElementsByClassName('.ant-message');

    const statusCode =
      res?.status ||
      res?.error?.status ||
      res?.error?.response?.status ||
      res?.data?.statusCode;

    const isSuccess =
      res?.data && !res.data.statusCode && typeof res.data !== 'string';

    if (isSuccess) {
      if (element.length === 0 && type && name) {
        message.success({
          content: t(`notification.success.${type}`, { name }),
          className: 'response-success',
          type: 'success',
        });
      }
      return { success: true, data: res.data };
    }

    if (element.length === 0 && statusCode !== 401) {
      const errorMessage = t(errorHandler(res?.error || res));
      message.error({
        content: errorMessage,
        className: 'response-error',
        type: 'error',
      });
    }

    return { success: false, data: '' };
  };
  return {
    checkResponse,
    t,
  };
}
